import React from 'react';
import SectionHeader from '../../Basic/SectionHeader';
import ContactPersonDOB from './ContactPersonDOB';
import ContactPersonPhone from './ContactPersonPhone';
import BillingAddress from '../CustomerDetails/Common/BillingAddress';

const SecondaryAccoundContact = ({ name, selectedAddress, isBusiness, disabled }) => {
    const lookup = window.osa && window.osa.lookup &&  window.osa.lookup.optionalCustomerDetails.secondAccountContact;
    return (
        <div className="form-group">
            <SectionHeader title={lookup.title} />
            <p>{lookup.text}</p>
            <p>{lookup.note}</p>
            {isBusiness ?
                <ContactPersonPhone name={name} disabled={disabled} />
                :
                <ContactPersonDOB name={name} disabled={disabled} />}
            <div className="row">
                <div className="col-sm-12">
                    <BillingAddress name={`${name}Address`} lookup={lookup.addressOption}
                        selectedBillingAddress={selectedAddress} inline disabled={disabled} />
                </div>
            </div>
        </div>
    );
};
SecondaryAccoundContact.propTypes = {
    name: React.PropTypes.string.isRequired,
    selectedAddress: React.PropTypes.string,
    isBusiness: React.PropTypes.bool,
    disabled: React.PropTypes.bool,
};
export default SecondaryAccoundContact;
